// v1.0 init card



// v1.1 fix up down scroll of card but git got cutoff
// App2.js: replace the listing grid with single row expandable card
import GoogleMapReact from "google-map-react";
import MarkerClusterer from "@googlemaps/markerclustererplus";
import logo from './logo.svg';
import './App.css';
import 'leaflet/dist/leaflet.css';
import React, { useState, useEffect, useRef } from 'react';
import { AppContainer } from './App.styles2';
import image from './images/location-map.svg';
import { Header, Card, GoogleMap, MinioFileList } from './components';
import data from './data';
import Cookies from 'js-cookie'; // For easier cookie handling
import axios from "axios";
import { TileLayer, useMapEvents } from "react-leaflet";
import MarkerForm from "./components/MarkerForm";
import Upload from "./components/Upload";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MapComponent from "./components/MapComponent_v2";
import Marker2 from "./components/Marker2";
// import Popup from "./components/Card/Popup_v3";
import Popup from "./components/Card/Popup_v4";
import FullScreenSidebar from "./components/FullScreenSidebar";
import { store } from './redux/MyRedux'
// import GridLayout from "./components/UserList"; // UserList -> in ExplorePage.js and imported as Gridlayout
// import UserPage from "./components/UserPage_v2";
// import UserPage from "./components/UserPage_v3";
import UserPage from "./components/UserPage_main";
// import MinioFileList from "./components";
// import HomePage from "./components/HomePage";
// import HomePage from "./components/HomePage_v1.1";
// import HomePage from "./components/HomePage_v1.2";
// import HomePage from "./components/HomePage_v1.3";
// import HomePage from "./components/HomePage_v1.4";
import HomePage from "./components/HomePage_v1.5";

import ExpandableCard from "./components/Reel/ExpandableCard"; // Import ExpandableCard
import MarkerDrawer from "./components/MarkerDrawer"; // Import MarkerDrawer
// import MarkerDrawer from "./components/MarkerDrawer v9.9 draft"; // Import MarkerDrawer


import Page1 from "./components/Page1";
import Page2 from "./components/Page2";
import Page3 from "./components/Page3";

import UserList from "./components/UserList";

import { GridAsymmetrical } from "./components/MapComponent Mantine";
import HomePageV2 from "./components/HomePageV2-failed";

// // map box
// import ReactMapGL from 'react-map-gl'; // Import react-map-gl
// import mapboxgl from 'mapbox-gl'; // Import Mapbox GL
// import 'mapbox-gl/dist/mapbox-gl.css'; // Import Mapbox CSS

// https://docs.mapbox.com/help/tutorials/use-mapbox-gl-js-with-react/
// import mapboxgl from 'mapbox-gl'
// import 'mapbox-gl/dist/mapbox-gl.css';

//https://codesandbox.io/p/sandbox/react-mapbox-draw-circle-forked-ji8zgq?file=%2Fsrc%2Findex.js%3A3%2C1-4%2C1
//https://stackoverflow.com/questions/75210457/mapbox-pins-dont-render
import ReactMapboxGl, { Marker } from "react-mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import MapInstance from "./components/MapBoxMap/MapInstance";
import { useMap } from "./components/MapBoxMap/MapInstance";
import { MapProvider } from "./components/MapBoxMap/MapInstance";
import RadioGlobeMap from "./components/RadioGlobeMap";

const Map = ReactMapboxGl({
  accessToken:
    "pk.eyJ1IjoibmhhbjEzMTk5OCIsImEiOiJjbTU5cjEwcHEwdTl5Mm1vOWg0ajB1aXF4In0.c07c-9Q_wzmye4OkxDA3sA"
});

// https://docs.goong.io/goong-map-react/docs/get-started/get-started -> look ugly and slow
// import ReactMapGL from '@goongmaps/goong-map-react';
// import '@goongmaps/goong-js/dist/goong-js.css';


// MinIO Configuration
const MINIO_ENDPOINT = "https://obj.tang17so82duytan.com";
const BUCKET_NAME = "demo-map";
const FILE_NAME = "location.json";

const center = {
  lat: 21.044175,
  lng: 105.846411,
};

// --- Sub-Component: ContentCard for Masonry Layout ---
const ContentCard = ({ data, onClick }) => {
  const LocationPin = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="white" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );

  const HeartIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#666' }}>
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    </svg>
  );

  const PlayIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="white" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ filter: 'drop-shadow(0 4px 3px rgb(0 0 0 / 0.3))' }}>
      <polygon points="5 3 19 12 5 21 5 3"></polygon>
    </svg>
  );

  const ImageIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ filter: 'drop-shadow(0 4px 3px rgb(0 0 0 / 0.3))' }}>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  );

  return (
    <div style={{
      marginBottom: '16px',
      // marginTop: data.isFirstColumn ? '4px' : 0,
      paddingTop: 0,
      breakInside: 'avoid',
      cursor: 'pointer',
      display: 'inline-block',
      width: '100%',
      verticalAlign: 'top',
      lineHeight: 'normal',
      fontSize: '14px'
    }} onClick={onClick}>
      {/* Image Container */}
      <div style={{
        position: 'relative',
        width: '100%',
        aspectRatio: data.aspectRatio || '3/4',
        backgroundColor: '#e5e7eb',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)'
      }}>
        <img
          src={data.imageUrl}
          alt={data.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "https://placehold.co/400x550/000000/FFFFFF?text=Content+Unavailable";
          }}
        />

        {/* Top Right Icons */}
        <div style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          zIndex: 10
        }}>
          {data.live && (
            <span style={{
              display: 'flex',
              alignItems: 'center',
              padding: '2px 8px',
              fontSize: '10px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#dc2626',
              borderRadius: '2px',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.3)'
            }}>
              LIVE
            </span>
          )}
          {!data.live && data.type === 'video' && <PlayIcon />}
          {!data.live && data.type === 'image' && <ImageIcon />}
          {!data.live && data.hasNotification && (
            <div style={{
              width: '12px',
              height: '12px',
              backgroundColor: '#dc2626',
              borderRadius: '50%',
              border: '2px solid white'
            }}></div>
          )}
        </div>

        {/* Location Badge */}
        {data.location && (
          <div style={{ position: 'absolute', bottom: '8px', left: '8px', zIndex: 10 }}>
            <span style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              padding: '4px 8px',
              fontSize: '10px',
              fontWeight: '500',
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.4)',
              backdropFilter: 'blur(2px)',
              borderRadius: '9999px',
              maxWidth: '140px'
            }}>
              <LocationPin />
              <span style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>{data.location}</span>
            </span>
          </div>
        )}
      </div>

      {/* Info Section */}
      <div style={{ marginTop: '6px', padding: '0 8px' }}>
        {/* Title */}
        <p style={{
          // fontSize: '16px',
          color: '#111827',
          fontWeight: '600',
          lineHeight: '1.25',
          // marginBottom: '8px',
          marginBottom: '4px',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          marginTop: '8px',
          WebkitTextStroke: '0.4px',
          fontSize: '0.9rem',


        }}>
          {data.title}
        </p>

        {/* User & Likes Row */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', overflow: 'hidden' }}>
            <div style={{
              width: '18px',
              height: '18px',
              backgroundColor: '#e5e7eb',
              borderRadius: '50%',
              flexShrink: 0,
              overflow: 'hidden'
            }}>
              <img
                src={`https://i.pravatar.cc/150?u=${data.id}`}
                alt="avatar"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
            <span style={{
              // fontSize: '14px',
              // color: '#6b7280',
              fontSize: '0.7rem',
              color: 'rgb(150, 150, 150)',

              fontWeight: '500',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              WebkitTextStroke: '0.3px'

            }}>{data.profileName}</span>
          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            flexShrink: 0,
            marginLeft: '8px'
          }}>
            <HeartIcon />
            <span style={{ fontSize: '14px', color: '#6b7280', fontWeight: '500' }}>{data.likes}</span>
          </div>
        </div>
      </div>
    </div>
  );
};



const v2failed_ContentCard = ({ data, onClick }) => {
  const LocationPin = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="white" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );

  const HeartIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#666' }}>
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    </svg>
  );

  const PlayIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="white" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ filter: 'drop-shadow(0 4px 3px rgb(0 0 0 / 0.3))' }}>
      <polygon points="5 3 19 12 5 21 5 3"></polygon>
    </svg>
  );

  const ImageIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ filter: 'drop-shadow(0 4px 3px rgb(0 0 0 / 0.3))' }}>
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  );

  return (
    <div style={{
      marginBottom: '10px',
      breakInside: 'avoid',
      cursor: 'pointer'
    }} onClick={onClick}>
      {/* Image Container */}
      <div style={{
        position: 'relative',
        width: '100%',
        aspectRatio: data.aspectRatio || '3/4',
        backgroundColor: '#e5e7eb',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)'
      }}>
        <img
          src={data.imageUrl}
          alt={data.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "https://placehold.co/400x550/000000/FFFFFF?text=Content+Unavailable";
          }}
        />

        {/* Top Right Icons */}
        <div style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          zIndex: 10
        }}>
          {data.live && (
            <span style={{
              display: 'flex',
              alignItems: 'center',
              padding: '2px 8px',
              fontSize: '10px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#dc2626',
              borderRadius: '2px',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.3)'
            }}>
              LIVE
            </span>
          )}
          {!data.live && data.type === 'video' && <PlayIcon />}
          {!data.live && data.type === 'image' && <ImageIcon />}
          {!data.live && data.hasNotification && (
            <div style={{
              width: '12px',
              height: '12px',
              backgroundColor: '#dc2626',
              borderRadius: '50%',
              border: '2px solid white'
            }}></div>
          )}
        </div>

        {/* Location Badge */}
        {data.location && (
          <div style={{ position: 'absolute', bottom: '8px', left: '8px', zIndex: 10 }}>
            <span style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              padding: '4px 8px',
              fontSize: '10px',
              fontWeight: '500',
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.4)',
              backdropFilter: 'blur(2px)',
              borderRadius: '9999px',
              maxWidth: '140px'
            }}>
              <LocationPin />
              <span style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>{data.location}</span>
            </span>
          </div>
        )}
      </div>

      {/* Info Section */}
      <div style={{ marginTop: '0px', padding: '0 8px', height: '60px', display: 'flex', flexDirection: 'column', }}>
        {/* Title */}
        <p style={{
          fontSize: '14px',
          color: '#111827',
          fontWeight: '600',
          lineHeight: '1.2',
          marginBottom: '0',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          marginTop: '8px',
          WebkitTextStroke: '0.4px'

        }}>
          {data.title}
        </p>

        {/* User & Likes Row */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', overflow: 'hidden' }}>
            <div style={{
              width: '20px',
              height: '20px',
              backgroundColor: '#e5e7eb',
              borderRadius: '50%',
              flexShrink: 0,
              overflow: 'hidden',
              marginTop: '8px',


            }}>
              <img
                src={data.userAvatar || `https://i.pravatar.cc/150?u=${data.id}`}
                alt="avatar"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
            <div>test</div>
            <span style={{
              fontSize: '12px',
              color: '#374151',
              fontWeight: '600',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {data.profileName2 || 'anonymous'}
            </span>
          </div>


          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '3px',
            flexShrink: 0,
            marginLeft: '6px'
          }}>
            <HeartIcon />
            <span style={{ fontSize: '12px', color: '#6b7280', fontWeight: '500' }}>{data.likes}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- StatusBar Component ---
const StatusBar = () => (
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 16px',
    zIndex: 40,
    backgroundColor: 'transparent',
    color: 'white'
  }}>
    <span style={{ fontSize: '14px', fontWeight: '600' }}>3:20</span>
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '14px' }}>
      <span style={{ fontSize: '12px' }}>✈️</span>
      <span style={{ fontWeight: '600' }}>99</span>
    </div>
  </div>
);

// --- AppHeader Component ---

const AppHeader = ({ activeTab, setActiveTab }) => {
  const scrollableTabs = ["Explore", "Users", "Friends", "Following", "Trending"];


  return (
    <header2 style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 30,
      // background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 30%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.2) 70%, transparent 100%)',
      // background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 60%, transparent 100%)',
      // background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0.35) 50%, rgba(0, 0, 0, 0) 100%)', //'linear-gradient(to bottom, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0.35) 50%, transparent 100%)', // best
      // backdropFilter: 'blur(30px) saturate(120%) brightness(1.2)',
      // WebkitBackdropFilter: 'blur(30px) saturate(120%) brightness(1.2)',
      // backdropFilter: 'blur(0.45px) saturate(120%) brightness(1)',
      // WebkitBackdropFilter: 'blur(0.45px) saturate(120%) brightness(1)',

      // background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0.35) 50%, rgba(0, 0, 0, 0) 100%)',

      // background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.45) 60%, transparent 100%)',

      // background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.35) 50%,  transparent 100%)',
      background: 'white',


      // background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 50%, transparent 100%)',
      // background: 'transparent',
      paddingTop: '8px',
      paddingBottom: '12px',
      transition: 'colors 0.3s'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', padding: '0 12px' }}>
        {/* LIVE Tab */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            fontSize: '14px',
            fontWeight: 'bold',
            flexShrink: 0,
            marginRight: '16px',
            cursor: 'pointer',
            WebkitTextStroke: '0.4px'

            // fontWeight: '900'   // thicker than 'bold'
          }}
          onClick={() => setActiveTab('LIVE')}
        >
          <span style={{
            padding: '2px 8px',
            borderRadius: '9999px',
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.3)',
            transition: 'colors 0.2s',
            ...(activeTab === 'LIVE'
              // ? { color: 'white', backgroundColor: '#dc2626' }
              ? { color: 'white', backgroundColor: '#dc2626' }
              // : { color: 'rgba(255, 255, 255, 0.9)', backgroundColor: 'rgba(255, 255, 255, 0.2)' })
              : { color: 'rgba(0, 0, 0, 0.9)', backgroundColor: 'rgba(255, 255, 255, 0.2)' })

          }}>
            LIVE
          </span>
        </div>

        {/* Scrollable Tabs */}
        <div style={{ flex: 1, overflowX: 'scroll', scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch' }} className="scrollbar-hide">
          <nav style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            fontSize: '16px',
            fontWeight: '600',
            color: 'rgba(255, 255, 255, 0.8)',
            minWidth: 'max-content',
            paddingRight: '48px',
            WebkitTextStroke: '0.4px'
          }}>
            {scrollableTabs.map((tab) => (
              <span
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  flexShrink: 0,
                  paddingTop: '4px',
                  paddingBottom: '4px',
                  position: 'relative',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                  transition: 'colors 0.2s',
                  ...(tab === activeTab
                    // ? { color: 'white', fontWeight: '800', filter: 'drop-shadow(0 4px 3px rgb(0 0 0 / 0.3))' }
                    ? { color: 'black', fontWeight: '800' } // **here: current tab color

                    // : { color: 'rgba(255, 255, 255, 0.7)' })
                    : { color: 'rgba(0, 0, 0, 0.5)' })

                }}
              >
                {tab}
                {tab === activeTab && (
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '80%',
                    height: '2px',
                    backgroundColor: 'black', // **here: this div is the underline
                    borderRadius: '9999px',
                    // paddingBottom: '2px',
                    // marginTop: '10px'
                    // boxShadow: '0 0 8px rgba(255, 255, 255, 0.8)'
                    // boxShadow: '0 0 8px rgba(255, 255, 255, 0.8)'

                  }}></div>
                )}
              </span>
            ))}
          </nav>
        </div>
      </div>
    </header2>
  );
};

// --- BottomNav Component ---
const BottomNav = () => (
  <div style={{
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'white',
    borderTop: '1px solid #f3f4f6',
    zIndex: 30,
    height: '56px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: '0 8px'
  }}>
    <span style={{ fontSize: '10px', fontWeight: '600', color: 'black' }}>Home</span>
    <span style={{ fontSize: '10px', fontWeight: '600', color: '#6b7280' }}>Shop</span>
    <div style={{
      width: '40px',
      height: '32px',
      borderRadius: '12px',
      backgroundColor: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>+</div>
    <span style={{ fontSize: '10px', fontWeight: '600', color: '#6b7280' }}>Inbox</span>
    <span style={{ fontSize: '10px', fontWeight: '600', color: '#6b7280' }}>Profile</span>
  </div>
);

export default function MapContainer() {
  const mapRef = useRef();
  let markersArray = [];
  const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const [properties, setProperties] = useState(data.properties);
  const [DefaultCenter] = useState(data.properties[0]);
  const [activeProperty, setActiveProperty] = useState(data.properties[0]);
  const [currentMarkerIndex, setCurrentMarkerIndex] = useState(0);
  const [filterIsVisible, setFilterIsVisible] = useState(false);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [isFiltering, setIsFiltering] = useState(false);
  const [markers, setMarkers] = useState([]);
  const [mapStyle, setMapStyle] = useState('light'); // 'dark', 'light', or 'satellite'

  useEffect(() => {
    if (markers && markers.length > 0 && activeProperty) {
      const initialIndex = markers.findIndex(marker => marker._id === activeProperty._id);
      if (initialIndex !== -1) {
        setCurrentMarkerIndex(initialIndex);
      }
    }
  }, [markers, activeProperty]);

  const goToPreviousMarker = () => {
    console.log('goToPreviousMarker called');
    if (markers) {
      setCurrentMarkerIndex((prevIndex) => (prevIndex === 0 ? markers.length - 1 : prevIndex - 1));
    }
  };

  const goToNextMarker = () => {
    console.log('goToNextMarker called');
    if (markers) {
      setCurrentMarkerIndex((prevIndex) => (prevIndex + 1) % markers.length);
    }
  };

  useEffect(() => {
    if (markers && markers.length > 0) {
      setActiveProperty(markers[currentMarkerIndex]);
    }
  }, [currentMarkerIndex, markers]);

  const [showPopup, setShowPopup] = useState(false);
  const [highlightedMarker, setHighlightedMarker] = useState(null); // State to track the highlighted marker

  const [isClicked, setIsClicked] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // const [places, setPlaces] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState(null);
  // const handleCartItemClick = (placeId) => {
  //   const place = markers.find((p) => p._id === placeId);
  //   setSelectedPlace(place);
  //   console.log("##### App.js _id #######")
  //   console.log(placeId)
  //   console.log(place._id)
  //   console.log(place)
  //   console.log(selectedPlace)
  //   console.log(selectedPlace._id)
  //   console.log("### done ###")

  // };

  const [mapCenter, setMapCenter] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(14);

  const [isMapView, setIsMapView] = useState(false); // State to toggle between views
  const [activeHeaderTab, setActiveHeaderTab] = useState('Explore'); // State for header tab navigation

  useEffect(() => {
    if (showPopup) {
      // Dispatch the "expand" action when showPopup is true
      store.dispatch({ type: "EXTEND" });
      // console.log("####### redux app.js extend #########")
      // console.log(store.getState().isExtented)
    } else {
      // Dispatch the "shrink" action when showPopup is false
      store.dispatch({ type: "SHRINK" });
      // console.log("####### redux app.js shrink #########")
      // console.log(store.getState().isExtented)
    }
  }, [showPopup]);

  // fix scroll up and down
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    setVH(); // Set on load
    window.addEventListener('resize', setVH);
    return () => window.removeEventListener('resize', setVH);
  }, []);


  const handleCartItemClick = (placeId) => {
    const place = markers.find((p) => p._id === placeId);
    setSelectedPlace(place);
    // console.log("##### App.js _id #######");
    // console.log(placeId);
    // console.log(place._id);
    // console.log(place);
  };

  // Use `useEffect` to track changes to `selectedPlace`
  useEffect(() => {
    if (selectedPlace) {
      // console.log("##### selectedPlace has changed #####");
      // console.log(selectedPlace._id);
      // console.log(selectedPlace);


      const lat = selectedPlace.location.coordinates[0];
      const lng = selectedPlace.location.coordinates[1];

      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;

      // Check if the screen is mobile or PC
      const isMobile = screenWidth <= 768;

      let newCenter = {};

      // temp disable offset
      if (false) {
        // For mobile, offset vertically (1/3 of the screen height)
        const offsetY = screenHeight / 3;  // 1/3 of the screen height
        const latitudeOffset = offsetY / 110540;  // Approximate conversion factor (meters per degree of latitude)

        newCenter = {
          lat: lat - latitudeOffset * 17,  // Adjust the latitude based on the offset
          // lat: lat - 0.0185,  // Adjust the latitude based on the offset
          lng: lng,  // Keep longitude the same
        };
      } else {
        // For PC, offset horizontally (1/3 of the screen width)
        const offsetX = screenWidth / 3;  // 1/3 of the screen width

        // Approximate 1 degree of longitude change is about 111320 meters at the equator
        const longitudeOffset = offsetX / 111320;  // Convert to degrees longitude

        console.log("############## App.js longitudeOffset ###########")
        console.log(longitudeOffset)

        newCenter = {
          lat: lat,  // Keep latitude the same
          lng: lng + longitudeOffset * 17,  // Adjust the longitude based on the offset
          // lng: lng +0.06,  // Adjust the longitude based on the offset

        };
      }

      // setZoomLevel(14)
      // console.log("############## App.js zoomLevel ###########")
      // console.log(zoomLevel)
      setMapCenter(newCenter);


    }
  }, [selectedPlace]); // This effect will run every time `selectedPlace` changes






  // disable zoom
  // useEffect(() => {
  //   const preventZoom = (event) => {
  //     // Prevent zoom with mouse wheel (Ctrl or Meta key)
  //     if (event.ctrlKey || event.metaKey) {
  //       event.preventDefault();
  //     }
  //   };

  //   const preventZoomKeyboard = (event) => {
  //     // Prevent zoom using keyboard shortcuts (Ctrl + '+' / '-' or Cmd + '+' / '-')
  //     if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-')) {
  //       event.preventDefault();
  //     }
  //   };

  //   const preventPinchZoom = (event) => {
  //     // Prevent pinch-to-zoom on touch devices
  //     if (event.touches.length > 1) {
  //       event.preventDefault();
  //     }
  //   };

  //   // Add event listeners for wheel (mouse zoom), keydown (keyboard zoom), and touch events (pinch zoom)
  //   document.addEventListener('wheel', preventZoom, { passive: false });
  //   document.addEventListener('keydown', preventZoomKeyboard, { passive: false });
  //   document.addEventListener('touchstart', preventPinchZoom, { passive: false });
  //   document.addEventListener('touchmove', preventPinchZoom, { passive: false });

  //   return () => {
  //     // Cleanup event listeners when the component is unmounted
  //     document.removeEventListener('wheel', preventZoom);
  //     document.removeEventListener('keydown', preventZoomKeyboard);
  //     document.removeEventListener('touchstart', preventPinchZoom);
  //     document.removeEventListener('touchmove', preventPinchZoom);
  //   };
  // }, []);


  const handleClosePopup = (e) => {
    e.stopPropagation(); // Prevent click from propagating to the overlay
    setIsClicked(false); // Close the popup
    setIsSidebarOpen(false); // Close the sidebar
  };

  const [handleFilter, setHandleFilter] = useState({
    filterBedrooms: 'any',
    filterBathrooms: 'any',
    filterCars: 'any',
    filterSort: 'any',
    priceFrom: '0',
    priceTo: '1000001',
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://192.168.0.102:3005/api/markers/';//'https://comtruaduytan.com/backend/api/markers/'
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://comtruaduytan.com/api/markers/';//'https://comtruaduytan.com/backend/api/markers/'


  const handleCardClick = (lat, lng) => {
    // Update the highlighted marker coordinates based on the card clicked
    setHighlightedMarker({ lat, lng });
  };

  const fetchMarkers = async () => {
    setLoading(true);
    setError(null);

    // Retrieve token from localStorage
    const token = localStorage.getItem('token');

    try {
      // Include the token in the Authorization header for the API request
      const response = await axios.get(apiBaseUrl, {
        headers: {
          Authorization: `Bearer ${token}`, // Add token to the Authorization header
        },
      });

      // setPlaces(response.data)
      console.log("########### fetch response App.js ######### ");
      console.log(response.data);
      setMarkers(response.data);  // Update the state with fetched markers
    } catch (error) {
      setError('Error fetching markers');
      console.error('Error fetching markers:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMarkers();
  }, []);

  const propertiesList = isFiltering ? filteredProperties : properties;

  // Function to toggle filter visibility
  function toggleFilter(e) {
    e.preventDefault();
    setFilterIsVisible(!filterIsVisible);
  }

  function handleFilterChange(e) {
    const { name, value } = e.target;
    setHandleFilter((prevState) => ({ ...prevState, [name]: value }));
  }

  function clearFilter(e, form) {
    e.preventDefault();
    setProperties(properties.sort((a, b) => a.index - b.index));
    setFilteredProperties([]);
    setActiveProperty(properties[0]);
    setIsFiltering(false);
    setHandleFilter((prevState) => ({
      ...prevState,
      filterBedrooms: 'any',
      filterBathrooms: 'any',
      filterCars: 'any',
      filterSort: 'any',
      priceFrom: '0',
      priceTo: '1000001',
    }));

    form.current.reset();
  }

  const handleMarkerClick = () => {
    // Disable pointer events on the map when a marker is clicked
    if (mapRef?.current && mapRef.current.googleMap) {
      const mapContainer = mapRef.current.googleMap.getDiv();
      mapContainer.style.pointerEvents = 'none'; // Disable pointer events
      setIsClicked(true);

      // Optionally, reset pointer events after a set time or an action
      setTimeout(() => {
        mapContainer.style.pointerEvents = 'auto'; // Enable pointer events again
        setIsClicked(false); // Reset the state
      }, 3000); // Adjust timeout duration as needed
    }
  };

  const [visibleMarkers, setVisibleMarkers] = useState([]);
  const [mapBounds, setMapBounds] = useState(null);
  const handleMapChange = ({ center, zoom, bounds }) => {
    setMapBounds(bounds);
    // Filter places that are within the bounds of the map
    const visible = markers.filter((place) =>
      bounds.contains({ lat: place.lat, lng: place.lng })
    );
    setVisibleMarkers(visible);
  };


  // const [gestureHandling, setGestureHandling] = useState('auto'); // Gesture handling state

  const [gestureHandling, setGestureHandling] = useState('greedy'); // Gesture handling state


  // mapbox
  // const [viewport, setViewport] = useState({
  //   latitude: 21.032275891056212,
  //   longitude: 105.81722252298444,
  //   zoom: 12,
  // });
  //   // Replace this with your Mapbox Access Token
  //   const mapboxAccessToken = 'pk.eyJ1IjoibmhhbjEzMTk5OCIsImEiOiJjbTU5cjEwcHEwdTl5Mm1vOWg0ajB1aXF4In0.c07c-9Q_wzmye4OkxDA3sA';

  //   // Customize your Mapbox style if needed
  //   const mapBoxStyle = 'mapbox://styles/mapbox/streets-v11';

  const [viewport, setViewport] = React.useState({
    latitude: 21.03072,
    longitude: 105.85239,
    zoom: 12
  });




  // fix jiggling


  // use shared map instance
  const map = useMap(); // Access the shared map instance
  useEffect(() => {
    if (map) {
      // You can perform additional map manipulation if needed, like adding markers or setting the center/zoom
      console.log('Shared map instance:', map);
      // Example: map.setCenter([105.8000, 21.0381]); // You can adjust the map center programmatically
    }

    console.log('App.js done useEffect');

  }, [map]);

  const toggleView = () => {
    setIsMapView(!isMapView);
  };

  return (
    // <MapProvider>
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <AppContainer>
              {/* listings - Start */}

              {isMapView ?


                // ////////////////// start map view here
                (
                  <>
                    <Header
                      filterIsVisible={filterIsVisible}
                      toggleFilter={toggleFilter}
                      clearFilter={clearFilter}
                      handleFilterChange={handleFilterChange}
                    // style = {{pointerEvents: 'auto',
                    // }}
                    />

                    {/* <h1 className="userList" style={{
                      zIndex: '1 !important',

                    }}>
                      <UserList className="userList" />
                    </h1> */}


                    <button
                      onClick={toggleView}
                      style={{
                        position: 'fixed',
                        bottom: '50%',
                        right: '10px',
                        padding: '5px',
                        fontSize: '16px',
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        zIndex: 1000,
                        width: '50px',
                        height: '30px',
                        fontSize: '11px', /* Smaller font size */
                        fontFamily: "'Nunito', sans-serif",
                        lineHeight: '1', /* Adjust text spacing */
                        WebkitTextStroke: '.7px ', /* Fix text stroke */
                        boxShadow: '0px 0px 5px rgba(173, 216, 230, 1)' /* Soft outer glow */
                      }}
                    >
                      Switch view
                    </button>

                    <>

                      <RadioGlobeMap
                        markers={markers}
                        selectedMarker={selectedPlace}
                        onMarkerClick={handleCartItemClick}
                        mapStyle={mapStyle}
                        onMapStyleChange={setMapStyle}
                      />

                      {/* <div className="mapContainer">
                        <div>
                          <Map
                            // style="mapbox://styles/mapbox/standard"
                            style="mapbox://styles/nhan131998/cm5e0e8o100fp01rg8n9a0ws6"
                            containerStyle={{
                              height: "100dvh",
                              width: "100vw"
                            }}
                            center={[105.8000, 21.0381]} // Set the default center of the map to Hanoi, Vietnam (Longitude, Latitude)
                            //     105.8542, 21.0285
                            zoom={[12]} // Set the default zoom level
                            pitch={[50]} // Set the default tilt (pitch) angle (45 degrees)
                            // dragRotate={false} // Disable rotation (dragRotate set to false)
                            // touchZoomRotate={false} // Disable zoom/rotate with touch gestures
                            scrollZoom={true} // Enable zoom with scroll
                            // doubleClickZoom={false} // Disable double click to zoom
                            bearing={[60]}
                            onStyleLoad={(map) => {
                              console.log('🗺️ Mapbox style loaded successfully');
                              console.log('📍 Protocol:', window.location.protocol);
                              console.log('🔒 Secure context:', window.isSecureContext);
                              console.log('🌐 Map instance:', map);
                            }}
                            onError={(error) => {
                              console.error('❌ Mapbox error:', error);
                            }}
                          >
                            <Marker coordinates={[-73.9857, 40.7484]}>
                              <div style={{ backgroundColor: 'red', padding: '10px', borderRadius: '50%' }}>
                                <span style={{ color: 'white', fontSize: '16px' }}>📍</span>
                              </div>
                            </Marker>

                            <Marker coordinates={[105.8000, 21.0381]}>
                              <div style={{
                                width: '80px',
                                height: '80px',
                                backgroundColor: 'white',
                                borderRadius: '50%',
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                                zIndex: 10,
                                pointerEvents: 'none'
                              }} />
                            </Marker>


                            {loading ? (
                              <p>Loading markers...</p>
                            ) : (
                              markers && markers.length > 0 ? (
                                markers.map((marker) => {
                                  const { coordinates } = marker.location; // Destructure coordinates
                                  const lat = coordinates[1]; // Latitude
                                  const lng = coordinates[0]; // Longitude

                                  // Log lat and lon for each marker
                                  // console.log(`Marker ID: ${marker._id}, Latitude: ${lat}, Longitude: ${lng}`);

                                  return (
                                    <Marker coordinates={[lat, lng]}>
                                      <Marker2
                                        key={marker._id} // Ensure each marker has a unique key
                                        lat={marker.location.coordinates[0]} // Latitude at index 1
                                        lng={marker.location.coordinates[1]} // Longitude at index 0
                                        text={marker.title} // Title of the marker
                                        property={marker}
                                        mapRef={mapRef}
                                        onClick={handleMarkerClick} // Trigger the handleMarkerClick function
                                        selectedPlace={selectedPlace}
                                        setGestureHandling={setGestureHandling}
                                      />
                                    </Marker>
                                  )
                                })
                              ) : (
                                <p>No markers available.</p>
                              )
                            )}
                          </Map>
                        </div>
                      </div> */}

                      {/* MarkerDrawer replaces the horizontal scrolling cards */}
                      <MarkerDrawer
                        markers={markers}
                        selectedMarker={selectedPlace}
                        onMarkerClick={handleCartItemClick}
                        mapStyle={mapStyle}
                      />

                      {/* Keep the warning message for filtering */}
                      {isFiltering && propertiesList.length === 0 && (
                        <p className="warning" style={{ pointerEvents: 'auto', position: 'fixed', bottom: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 100 }}>
                          <img src={image} alt="No properties were found." />
                          <br />
                          No properties were found.
                        </p>
                      )}

                      {/* Keep the Popup logic */}
                      {showPopup && activeProperty && (
                        <Popup property={activeProperty} setShowPopup={setShowPopup} />
                      )}
                      {/* Close listings div */}
                    </>
                  </>
                ) :
                // ////////////////// end map view here


                // ////////////////// start grid view here
                (
                  <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 10,
                    backgroundColor: '#fefefe',
                    // backgroundColor: 'rgb(241, 241, 241)',
                    paddingBottom: '5px',
                    paddingTop: '0px',

                  }}>
                    <Header
                      filterIsVisible={filterIsVisible}
                      toggleFilter={toggleFilter}
                      clearFilter={clearFilter}
                      handleFilterChange={handleFilterChange}
                    />

                    {/* <StatusBar /> */}
                    <AppHeader activeTab={activeHeaderTab} setActiveTab={setActiveHeaderTab} />

                    {/* Render UserList only on Explore tab */}
                    {activeHeaderTab === 'Users' && (
                      <div style={{ padding: '16px', paddingTop: '60px' }}>
                        <UserList />
                      </div>
                    )}

                    {/* Render Cards only on Explore tab */}
                    {activeHeaderTab === 'Explore' && (
                      <div
                        style={{
                          // marginTop: '50%', // match the height of Header + UserList
                          // padding: '10px',
                          // height: 'calc(100dvh - 30dvh)',
                          // height: '77dvh',
                          // height: '90dvh',
                          height: '100dvh',
                          // width: '90dvw',
                          overflowY: 'auto', //'auto',
                          overflowX: 'hidden',
                          backgroundColor: '#fefefe',
                          fontFamily: "'Nunito', sans-serif",
                          fontSize: '24px',
                          color: '#333',
                          // scrollPaddingBottom: "60px" does not work, temp add an element to the bottom

                          // top: '100px'
                        }}>


                        {/* br that pushes cards down is here */}
                        {/* <br /> */}
                        {/* <br />
                        <br /> */}
                        <span style={{ display: "block", height: "2.1em" }}></span>

                        {/* === Switch View Button (optional fixed or floating) === */}
                        <button
                          onClick={toggleView}
                          style={{
                            position: 'fixed',
                            bottom: '50%',
                            right: '10px',
                            padding: '5px',
                            fontSize: '16px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            zIndex: 1000,
                            width: '50px',
                            height: '30px',
                            fontSize: '11px', /* Smaller font size */
                            fontFamily: "'Nunito', sans-serif",
                            lineHeight: '1', /* Adjust text spacing */
                            WebkitTextStroke: '.7px ', /* Fix text stroke */
                            boxShadow: '0px 0px 5px rgba(173, 216, 230, 1)' /* Soft outer glow */
                          }}
                        >
                          Switch view
                        </button>

                        {/* === Cards List === */}
                        <div style={{
                          display: 'flex',
                          gap: '4px',
                          padding: '0 4px',
                          marginTop: '2px'
                        }}>
                          {/* Left Column */}
                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            {markers
                              .filter((_, index) => index % 2 === 0)
                              .map((marker) => {
                                const selectedAspectRatio = '3/4';
                                const firstMedia = marker.media && marker.media.length > 0 ? marker.media[0] : null;
                                const isVideo = firstMedia && (firstMedia.type === 'video' || firstMedia.url.endsWith('.mp4'));

                                const cardData = {
                                  id: marker._id,
                                  title: marker.title || 'Untitled',
                                  location: marker.address || marker.location?.address,
                                  profileName: marker.author || 'Anonymous User',
                                  userAvatar: marker.userAvatar || null,
                                  likes: marker.likes || '0',
                                  imageUrl: firstMedia
                                    ? (isVideo && firstMedia.thumbnailUrl
                                      ? `https://${firstMedia.thumbnailUrl}`
                                      : `https://${firstMedia.url}`)
                                    : "https://images.unsplash.com/photo-1545656513-a4478170ba36?q=80&w=1000&auto=format&fit=crop",
                                  live: marker.live || false,
                                  type: isVideo ? 'video' : (marker.type || 'image'),
                                  aspectRatio: selectedAspectRatio,
                                  hasNotification: marker.hasNotification || false,
                                };

                                return (
                                  <ContentCard
                                    key={marker._id}
                                    data={cardData}
                                    onClick={() => {
                                      handleCartItemClick(marker._id);
                                      setActiveProperty(marker);
                                      setShowPopup(true);
                                    }}
                                  />
                                );
                              })}
                          </div>

                          {/* Right Column */}
                          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                            {markers
                              .filter((_, index) => index % 2 === 1)
                              .map((marker) => {
                                const selectedAspectRatio = '3/4';
                                const firstMedia = marker.media && marker.media.length > 0 ? marker.media[0] : null;
                                const isVideo = firstMedia && (firstMedia.type === 'video' || firstMedia.url.endsWith('.mp4'));

                                const cardData = {
                                  id: marker._id,
                                  title: marker.title || 'Untitled',
                                  location: marker.address || marker.location?.address,
                                  profileName: marker.author || 'Anonymous User',
                                  userAvatar: marker.userAvatar || null,
                                  likes: marker.likes || '0',
                                  imageUrl: firstMedia
                                    ? (isVideo && firstMedia.thumbnailUrl
                                      ? `https://${firstMedia.thumbnailUrl}`
                                      : `https://${firstMedia.url}`)
                                    : "https://images.unsplash.com/photo-1545656513-a4478170ba36?q=80&w=1000&auto=format&fit=crop",
                                  live: marker.live || false,
                                  type: isVideo ? 'video' : (marker.type || 'image'),
                                  aspectRatio: selectedAspectRatio,
                                  hasNotification: marker.hasNotification || false,
                                };

                                return (
                                  <ContentCard
                                    key={marker._id}
                                    data={cardData}
                                    onClick={() => {
                                      handleCartItemClick(marker._id);
                                      setActiveProperty(marker);
                                      setShowPopup(true);
                                    }}
                                  />
                                );
                              })}
                          </div>
                        </div>

                        <div style={{ height: "20dvh", background: "white" }}></div>


                        {/* === Empty State === */}
                        {isFiltering && propertiesList.length === 0 && (

                          <p className="warning">
                            <img src={image} alt="No properties were found." />
                            <br />
                            No properties were found.
                          </p>
                        )}

                        {/* === Popup === */}
                        {showPopup && activeProperty && (
                          <Popup
                            property={activeProperty}
                            setShowPopup={setShowPopup}
                            goToPreviousMarker={goToPreviousMarker}
                            goToNextMarker={goToNextMarker}
                            currentMarkerIndex={currentMarkerIndex}
                          />
                        )}
                      </div>
                    )}

                    {/* Add BottomNav */}
                    {/* <BottomNav /> */}
                  </div>

                )}
              {/* // ////////////////// end grid view here */}

            </AppContainer> // Correctly closing AppContainer here
          } // Closing element prop
        />
        {/* Other Routes */}
        <Route path="/marker" element={<MapComponent />} />
        <Route path="/user/:id" element={<UserPage />} />
        <Route path="/media/files" element={<MinioFileList />} />
        <Route path="/homepage" element={<HomePage />} />
        <Route path="/man" element={<GridAsymmetrical />} />

        <Route path="/page1" element={<Page1 />} />
        <Route path="/page2" element={<Page2 />} />
        <Route path="/page3" element={<Page3 />} />

      </Routes>

    </Router > // Closing Router
    // </MapProvider>
  ); // Closing return statement
} // Closing MapContainer function

// Raindrop Component
const RainDrop = ({ initialCoordinates, speed = 0.0001, size = 5 }) => {
  const [dropPosition, setDropPosition] = useState(initialCoordinates);
  const [falling, setFalling] = useState(true);

  useEffect(() => {
    const animateRainDrop = () => {
      let dropLongitude = dropPosition[0];
      let dropLatitude = dropPosition[1];

      // Move the raindrop downwards (latitude decreases)
      if (falling) {
        dropLatitude -= speed; // Move raindrop down
        if (dropLatitude < 20.0) { // If the raindrop reaches the bottom, reset position
          dropLatitude = 21.5; // Reset to top
          dropLongitude = 105.85 + Math.random() * 0.2; // Randomize longitude
        }
      }

      // Update raindrop position
      setDropPosition([dropLongitude, dropLatitude]);
    };

    const interval = setInterval(animateRainDrop, 50);

    return () => clearInterval(interval);
  }, [dropPosition, falling, speed]);

  return (
    <Marker coordinates={dropPosition}>
      <div
        style={{
          width: `${size}px`,
          height: `${size}px`,
          backgroundColor: 'rgba(0, 0, 255, 0.6)',  // Blue color for the raindrop
          borderRadius: '50%', // Circle shape
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)', // Optional: Shadow for floating effect
        }}
      />
    </Marker>
  );
};

// RainAnimation Component
const RainAnimation = ({ numDrops = 50, speed = 0.0001 }) => {
  const drops = Array.from({ length: numDrops }, () => ({
    coordinates: [105.85 + Math.random() * 0.2, 21.5], // Randomize longitude positions
  }));

  return (
    <div>
      {drops.map((drop, index) => (
        <RainDrop
          key={index}
          initialCoordinates={drop.coordinates}
          speed={speed}
        />
      ))}
    </div>
  );
};


const FlyingCloud = ({ initialCoordinates, numberOfRaindrops = 100, rainOffsetX = 10 }) => {
  const [raindrops, setRaindrops] = useState([]);

  // Number of lumps the cloud has
  const cloudLumps = [
    { xOffset: 5, yOffset: 5 },
    { xOffset: 25, yOffset: 15 },
    { xOffset: 60, yOffset: 5 },
    { xOffset: 75, yOffset: 20 },
    { xOffset: 105, yOffset: 35 },
  ];

  // Generate initial raindrop positions and speeds
  useEffect(() => {
    const generateRaindrops = () => {
      const newRaindrops = [];

      for (let i = 0; i < numberOfRaindrops; i++) {
        const randomLump = cloudLumps[Math.floor(Math.random() * cloudLumps.length)];

        newRaindrops.push({
          id: i,
          startX: randomLump.xOffset + Math.random() * 20 - 10, // Random X offset around the lump
          startY: randomLump.yOffset + 30, // Start slightly below the lump
          endY: randomLump.yOffset + 80 + Math.random() * 50, // Random fall distance
          positionX: randomLump.xOffset + Math.random() * 20 - 10 + rainOffsetX, // Apply the horizontal offset
          positionY: randomLump.yOffset + 30, // Start slightly below the lump
          speed: Math.random() * 2 + 2, // Random speed for each raindrop
          isFalling: true,
        });
      }
      setRaindrops(newRaindrops);
    };

    generateRaindrops();
  }, [numberOfRaindrops, rainOffsetX]); // Re-run the generation if offset or number changes

  // Move raindrops at a fixed interval
  useEffect(() => {
    const interval = setInterval(() => {
      setRaindrops((prevRaindrops) =>
        prevRaindrops.map((drop) => {
          if (drop.isFalling) {
            if (drop.positionY < drop.endY) {
              return {
                ...drop,
                positionY: drop.positionY + drop.speed, // Move raindrop down with its own speed
              };
            } else {
              // Reset raindrop to the starting position after falling for 2 seconds
              return {
                ...drop,
                positionY: drop.startY,
                isFalling: true, // Set to falling state again
              };
            }
          }
          return drop;
        })
      );
    }, 50); // 50ms interval for smoother animation

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  return (
    <Marker coordinates={initialCoordinates}>
      <div style={{
        position: 'relative',
        width: '120px',
        height: '60px',
        zIndex: 10,
      }}>
        {/* Cloud Lumps */}
        <div style={{
          position: 'absolute',
          width: '40px',
          height: '20px',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          borderRadius: '50px',
          top: '5px',
          left: '5px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
        }}></div>

        <div style={{
          position: 'absolute',
          width: '50px',
          height: '25px',
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          borderRadius: '50px',
          top: '15px',
          left: '25px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
        }}></div>

        <div style={{
          position: 'absolute',
          width: '45px',
          height: '25px',
          backgroundColor: 'rgba(255, 255, 255, 0.75)',
          borderRadius: '50px',
          top: '5px',
          left: '60px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
        }}></div>

        <div style={{
          position: 'absolute',
          width: '60px',
          height: '30px',
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          borderRadius: '50px',
          top: '20px',
          left: '75px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
        }}></div>

        <div style={{
          position: 'absolute',
          width: '50px',
          height: '20px',
          backgroundColor: 'rgba(255, 255, 255, 0.75)',
          borderRadius: '50px',
          top: '35px',
          left: '105px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
        }}></div>

        {/* Raindrops */}
        {raindrops.map((drop) => (
          <div
            key={drop.id}
            style={{
              position: 'absolute',
              top: `${drop.positionY}px`,
              left: `${drop.positionX}px`,
              width: '2px',
              height: '12px', // Thinner and longer raindrop
              backgroundColor: 'rgb(196,230,248)', // Raindrop color
              borderRadius: '2px', // Round edges for a smooth look
              animation: 'fall 2s linear infinite', // Smooth falling effect
              opacity: Math.random() * 0.6 + 0.4, // Random opacity for realism
            }}
          />
        ))}
      </div>
    </Marker>
  );
};
